import React from "react";
import Core from "../components/Core";
import Template48306Component from "./Template48306Component";

import screenProvider from "../services/CommonScreenProvider";
import dataProvider from "../services/CommonDataProvider";
import { baseEventHandler } from "../services";

export default class Template48306Container extends React.Component {
    render() {
        return (
            <Core
                screenProvider={screenProvider}
                eventHandler={baseEventHandler}
                dataProvider={dataProvider}
                scrollLimit={2}
                {...this.props}
            >
                {(props) => <Template48306Component {...props} />}
            </Core>
        );
    }
}
